import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  errorTextMessage: {
    width: '300%',
  },
  suffixAndPrefix: {
    color: '#B1B1B1'
  },
  textFieldSuffix: {
    '& input': {
      paddingRight: '0px !important'
    },
    '& div': {
      paddingRight: '0px',
    }
  },
  textFieldPrefix: {
    '& input': {
      paddingLeft: '0px !important'
    },
    '& div': {
      paddingLeft: '4px',
    }
  },
  textField: {
    maxHeight: '38px',
    '& input': {
      padding: '9px'
    },
    margin: '9px'
  },
  textFieldShort: {
    maxWidth: '76px',
    maxHeight: '38px',
    '& input': {
      padding: '9px'
    },
    margin: '9px'
  },
  textFieldFill: {
    width: 'calc(100% - 18px)',
    maxHeight: '38px',
    '& input': {
      padding: '9px'
    },
    margin: '9px'
  },
  textFieldFillMultiline: {
    width: 'calc(100% - 18px)',
    maxHeight: '304px',
    '& input': {
      padding: '9px'
    },
    margin: '9px'
  },
  multiline: {
    maxHeight: '304px',
  },
  textFieldDisabled: {
    color: '#595959',
    background: '#D3D3D3',
    '& .MuiOutlinedInputNotchedOutline': {
      border: '1px solid #D3D3D3 !important'
    }
  },
  textFieldFocus: {
    backgroundColor: '#EEF2FF',
    '& .MuiOutlinedInputNotchedOutline': {
      border: '1px solid #0F44FF !important',
    }
  },
  textFieldError: {
    '& input': {
      color: 'rgba(0, 0, 0, 0.87) !important',

    },
    '& .MuiOutlinedInputNotchedOutline': {
      border: '1px solid #FF3232 !important',
    },
    '& .Mui-error': {
      color: '#FF3232',
      marginLeft: 0
    }
  }
});

export const useIDKStyles = makeStyles({
  idkRoot: {
    marginTop: '-0.5rem',
    marginLeft: '1rem'
  }
});